import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { take } from 'rxjs';

import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';

import { VisitDialog, VisitDialogLabels } from '@hm/core/models/medical-entity-modal.const';
import { MemberProfilesService } from '@lib/members/data-access';

import { formatDate } from '@lib/commons/util-functions/format-date.function';
import { SpinLoadingComponent } from '@lib/shared-ui/commons/spin-loading/spin-loading.component';
import { StatusComponent } from '@lib/shared-ui/commons/status/status.component';

@Component({
  selector: 'hm-visit-view-modal',
  imports: [MatDialogClose, MatDivider, MatIcon, StatusComponent, SpinLoadingComponent, TranslatePipe],
  templateUrl: './visit-view-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisitViewModalComponent {
  private readonly router = inject(Router);
  private readonly memberService = inject(MemberProfilesService);
  private readonly dialogRef = inject(MatDialogRef<VisitViewModalComponent>);
  private readonly snackbar = inject(MatSnackBar);
  protected readonly data: VisitDialog = inject(MAT_DIALOG_DATA);

  protected readonly visitDialogLabels = VisitDialogLabels;
  protected readonly formatDateFunction = formatDate;

  protected navigationBtnLoading = signal<boolean>(false);

  navigateToGuaranteeApplication(userId?: string, guaranteeId?: string) {
    this.navigationBtnLoading.set(true);
    return this.memberService
      .getClientProfileByUserId(userId)
      .pipe(take(1))
      .subscribe({
        next: profile => {
          this.router.navigate([`clients/${profile.id}/medical-services/${guaranteeId}/details`]).then(() => this.dialogRef.close());
        },
        error: () => {
          this.navigationBtnLoading.set(false);
          this.snackbar.open('Не вдалося здійснити перехід до медичної послуги', 'OK', { duration: 5000 });
        },
      });
  }
}
